/**
 * @desc 批量绑定箱子
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBatchBoxBindSkuRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/batchBindSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
